<div
  class="grid grid-cols-[auto_1fr] gap-4 border-1"
  [ngClass]="{
    'border-yellow-100 bg-yellow-50 text-grey': type === 'info',
    'border-blue-100 bg-blue-50 text-grey': type === 'notice',
    'border-orange-100 bg-orange-50 text-grey': type === 'warning',
    'border-green-100 bg-green-50 text-grey': type === 'success',
    'border-red-100 bg-red-50 text-grey': type === 'error',

    'gap-2 rounded-[3px] px-2 py-1': size === 'small',
    'gap-3 rounded-md px-4 py-1.5': size === 'default',
    'gap-4 rounded-lg px-6 py-2': size === 'large',
  }"
>
  <div class="row-start-1 row-end-2 flex items-center">
    @if (showIcon) {
      <svg-icon
        data-test-id="icon"
        [src]="iconSrc"
        [ngClass]="{
          'text-yellow': type === 'info',
          'text-blue-600': type === 'notice',
          'text-orange': type === 'warning',
          'text-green-600': type === 'success',
          'text-red-600': type === 'error',

          'size-4': size === 'small',
          'size-5': size === 'default',
          'size-8': size === 'large',
        }"
      />
    }
  </div>
  <div
    data-test-id="title"
    class="row-start-1 row-end-2 flex items-center"
    [ngClass]="{
      'text-xs font-medium': size === 'small',
      'text-sm': size === 'default',
      'text-xl': size === 'large',
    }"
  >
    @if (hasTitle) {
      <ng-content select="[alertTitle]" />
    } @else {
      <ng-content />
    }
  </div>

  @if (hasBody) {
    <div class="row-start-2 row-end-3"></div>
    <div class="row-start-2 row-end-3 flex items-start">
      <ng-content select="[alertBody]" />
    </div>
  }
</div>
